export const DEVICE_ID_COOKIE_NAME = "device_id";
export const COOKIE_CONSENT_COOKIE_NAME = "cookie_consent";

export const MARKETING_COOKIES = [
  "__cf_bm",
  "__hs_cookie_cat_pref",
  "__hssc",
  "__hssrc",
  "__hstc",
  "_cfuvid",
  "_fbp",
  "_ga",
  "_gcl_au",
  "hubspotutk",
  "personalization_id",
];
